module.exports = __webpack_public_path__ + "static/media/1_pl.6f37f42e.png";